import { Injectable } from '@angular/core';
import { System } from '@app/core/resources/system';
import { SystemsService } from '@app/core/services/systems.service';
import { Observable, filter, take } from 'rxjs';

export type GetLandingSystemMode = 'base' | 'details';

export const LANDING_SYSTEM_DETAILS_INCLUDE: ReadonlyArray<string> = [
    'rates',
    'currency',
    'networks',
];

export interface GetLandingSystemUseCaseParams {
    systemId: string;
    mode: GetLandingSystemMode;
}

@Injectable({
    providedIn: 'root',
})
export class GetLandingSystemUseCase {
    public constructor(private readonly systemsService: SystemsService) {}

    public execute(params: GetLandingSystemUseCaseParams): Observable<System> {
        return this.systemsService
            .get(params.systemId, {
                include: this.getIncludeByMode(params.mode),
                ttl: 0,
            })
            .pipe(
                filter((system: System): boolean => system.source !== 'new' && system.loaded),
                take(1),
            );
    }

    private getIncludeByMode(mode: GetLandingSystemMode): Array<string> {
        if (mode === 'details') {
            return [...LANDING_SYSTEM_DETAILS_INCLUDE];
        }

        return [];
    }
}
